<template>
    <div class="container d-flex justify-content-center text-center">
        <h2 class="text-white">
            {{ confirmed ? '' : $t('message.mailChangeFailed') }}
        </h2>
    </div>
</template>

<script>
    import api from '../api';
    import { USER_SET_STATUS } from 'mutations/user';

    export default {
        name: 'ConfirmMail',

        data() {
            return {
                confirmed: true
            };
        },

        async created() {
            if (this.$route.query.token) {
                let response = await api.post('/app/mail/confirm', {
                    token: this.$route.query.token
                });

                if (response && response.status === this.$defines.RESPONSE_STATUS.OK) {
                    await this.$store.commit(`user/${USER_SET_STATUS}`, this.$defines.AUTHORIZE_STATUS.ACCOUNT_EXISTS);
                    await this.$router.push('/account?mailChanged=true');
                }
                else {
                    this.confirmed = false;
                }
            }
        }
    };
</script>
